import { CategoryFiltersResponse } from '@screens/Category/model/types/categoryFilters';
import { SERVER_URL } from '@shared/config/api/api';

export const getFiltersForCategory = async (category: string): Promise<CategoryFiltersResponse> => {
  try {
    const response = await fetch(`${SERVER_URL}/products/filters/${category}`, {
      next: {
        tags: ['catalog']
      }
    });
    const data = await response.json();
    return await data;
  } catch (error) {
    console.error(error);
    throw new Error('Network error');
  }
};
